import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * Title
 *
 * This component is in charge of displaying
 * a slide title
 *
 * @return {jsx}
 */

const Title = ({ className, children }) => <h1 className={className}>{children}</h1>;

/**
 * Display Name
 */
Title.displayName = 'Slide.Title';

/**
 * PropTypes Validation
 */
const { node, string } = PropTypes;
Title.propTypes = {
  className: string,
  children: node,
};

/**
 * Default Props
 */
Title.defaultProps = {
  className: '',
  children: null,
};

export default styled(Title)`
  font-size: ${({ theme: { fonts } }) => fonts.size.h4};
  font-weight: ${({ theme: { fonts } }) => fonts.weight.thick};
  color: ${({ theme: { palette } }) => palette.darkBlue};
  margin-bottom: ${({ theme: { fonts } }) => fonts.size.small};

  @media (max-width: 350px) {
    font-size: ${({ theme: { fonts } }) => fonts.size.h6};
  }
`;



// WEBPACK FOOTER //
// ./src/components/Slide/Title/index.js